"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _NonMerchandiseIdIdentifers = require("pricing-pages-unified-ui/constants/NonMerchandiseIdIdentifers");

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

var _PriceDisplay = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/pricing/PriceDisplay"));

var _CurrencySelectors = require("pricing-pages-unified-ui/selectors/CurrencySelectors");

var _LoadingStateSelectors = require("pricing-pages-unified-ui/selectors/LoadingStateSelectors");

var _PricingSelectors = require("../../selectors/PricingSelectors");

var _MarketingContactsSelectors = require("pricing-pages-unified-ui/selectors/MarketingContactsSelectors");

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)([""]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    text-align: center !important;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-top: 10px;\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n  font-size: 16px;\n  font-weight: bold;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 27px;\n  display: block;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n  font-size: 20px;\n  font-weight: 500;\n  padding: 0 7px 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// for horizontal card
var HorizontalPriceDisplay = (0, _styledComponents.default)(_PriceDisplay.default).withConfig({
  displayName: "CmsMarketingBundlePriceDisplay__HorizontalPriceDisplay",
  componentId: "guhxoc-0"
})(_templateObject(), _colors.PANTERA); //For highlighted merch card

var VerticalPriceDisplay = (0, _styledComponents.default)(_PriceDisplay.default).withConfig({
  displayName: "CmsMarketingBundlePriceDisplay__VerticalPriceDisplay",
  componentId: "guhxoc-1"
})(_templateObject2(), _colors.PANTERA);

var SimplifiedPriceDisplayContainer = _styledComponents.default.div.withConfig({
  displayName: "CmsMarketingBundlePriceDisplay__SimplifiedPriceDisplayContainer",
  componentId: "guhxoc-2"
})(_templateObject3(), _colors.OLAF);

var StyledPriceDisplay = _styledComponents.default.div.withConfig({
  displayName: "CmsMarketingBundlePriceDisplay__StyledPriceDisplay",
  componentId: "guhxoc-3"
})(_templateObject4(), _responsiveBreakpoints.default.tablet(_templateObject5()));

var PriceContainer = _styledComponents.default.span.withConfig({
  displayName: "CmsMarketingBundlePriceDisplay__PriceContainer",
  componentId: "guhxoc-4"
})(_templateObject6());

var CmsMarketingBundlePriceDisplay = function CmsMarketingBundlePriceDisplay(_ref) {
  var activeCurrencyCode = _ref.activeCurrencyCode,
      calculateBundlePrice = _ref.calculateBundlePrice,
      hasPricingAndPurchasingSucceeded = _ref.hasPricingAndPurchasingSucceeded,
      _ref$verticalPriceDis = _ref.verticalPriceDisplay,
      verticalPriceDisplay = _ref$verticalPriceDis === void 0 ? false : _ref$verticalPriceDis,
      _ref$simplified = _ref.simplified,
      simplified = _ref$simplified === void 0 ? false : _ref$simplified;
  var isInMCBeta = (0, _reactRedux.useSelector)(_MarketingContactsSelectors.isInMCBetaSelector);

  if (!hasPricingAndPurchasingSucceeded) {
    return null;
  }

  var pricingInfo = calculateBundlePrice({
    bundleSelections: {
      marketingPlanSelected: isInMCBeta ? _MerchandiseIds.PRODUCT_MARKETING_STARTER_MC : _MerchandiseIds.PRODUCT_MARKETING_STARTER_NOV_2019,
      cmsPlanSelected: _MerchandiseIds.PRODUCT_CMS_PROFESSIONAL
    }
  });
  var propsToPass = {
    currencyCode: activeCurrencyCode,
    price: pricingInfo.monthly.calculatedPrice,
    merchandiseId: isInMCBeta ? _NonMerchandiseIdIdentifers.CMS_STARTER_MC_BUNDLE : _NonMerchandiseIdIdentifers.CMS_STARTER_BUNDLE // Just for selenium test purposes (see en.lyaml implementation)

  };
  return _react.default.createElement(StyledPriceDisplay, null, simplified ? _react.default.createElement(SimplifiedPriceDisplayContainer, null, _react.default.createElement(_PriceDisplay.default, propsToPass), _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.priceDisplay.perMonth"
  })) : _react.default.createElement(_FormattedJSXMessage.default, {
    message: "pricingPage.pricingPerMonth_jsx",
    options: propsToPass,
    elements: {
      MicroCopy: _Small.default,
      PriceDisplay: verticalPriceDisplay ? VerticalPriceDisplay : HorizontalPriceDisplay,
      PriceContainer: PriceContainer
    }
  }));
};

CmsMarketingBundlePriceDisplay.propTypes = {
  activeCurrencyCode: _propTypes.default.string.isRequired,
  hasPricingAndPurchasingSucceeded: _propTypes.default.bool.isRequired,
  verticalPriceDisplay: _propTypes.default.bool,
  simplified: _propTypes.default.bool,
  calculateBundlePrice: _propTypes.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    activeCurrencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    hasPricingAndPurchasingSucceeded: (0, _LoadingStateSelectors.hasPricingAndPurchasingSucceededSelector)(state),
    calculateBundlePrice: (0, _PricingSelectors.getCalculateBundlePriceSelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(CmsMarketingBundlePriceDisplay);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/product-pages/CmsMarketingBundlePriceDisplay.js
// module id = 490
// module chunks = 5 6